import { FC, memo } from 'react';
import CarouselImages from './carouselImages/CarouselImages';
import Box from '@/components/UI/box/Box';
import styles from './ProductCardImages.module.scss';
type ProductCardImagesProps = {
  thumbnail: string;
  pictures: any;
  title: string;
  isFirstCard?: boolean;
};
const ProductCardImages: FC<ProductCardImagesProps> = ({
  thumbnail,
  pictures,
  title,
  isFirstCard
}) => {
  const picturesList = pictures?.filter(img => !img.is_default) || [];
  const images = [thumbnail, ...(picturesList || []).map(photo => photo?.thumbnail_absolute_url)];
  return <Box className={styles['product_card_images_container']} data-sentry-element="Box" data-sentry-component="ProductCardImages" data-sentry-source-file="ProductCardImages.tsx">
      <CarouselImages images={images} title={title?.trim()} isFirstCard={isFirstCard} data-sentry-element="CarouselImages" data-sentry-source-file="ProductCardImages.tsx" />
    </Box>;
};
export default memo(ProductCardImages);